import { render, staticRenderFns } from "./BigCheckBox.vue?vue&type=template&id=55ca9551&scoped=true&"
import script from "./BigCheckBox.vue?vue&type=script&lang=js&"
export * from "./BigCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./BigCheckBox.vue?vue&type=style&index=0&id=55ca9551&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca9551",
  null
  
)

export default component.exports